import { ChallengeGroupModelDto } from '@treasury/api/bo';
import { DomainEntity } from '../../../../shared';

const defaultCompany: ChallengeGroupModelDto = {
    id: 0,
    name: '',
    isDefault: false,
};

export class ChallengeGroup extends DomainEntity<ChallengeGroupModelDto> {
    public id = this.dto.id;

    public name = this.dto.name;

    public isDefault = this.dto.isDefault;

    public description = this.dto.description;

    public createDefault(): this {
        return new ChallengeGroup(defaultCompany) as this;
    }
}
